import Image from "@Components/Image";
import { CMSImageType } from "@Types/Contentful";
import classes from "./MediaImage.module.scss";

export interface MediaImageProps {
  image?: CMSImageType;
}

export default function MediaImage(props: MediaImageProps) {
  const { image } = props;

  return (
    <section className="section">
      <div className={`section__content ${classes["media-image"]}`}>
        {image && (
          <Image
            src={`${image?.url}?fm=webp&w=1920&h=1080` ?? ""}
            alt={image?.title}
            width={image?.width}
            height={image?.height}
            objectFit="cover"
          />
        )}
      </div>
    </section>
  );
}
